<template>
  <ag-modal-container
    :title="$t('user.title.createUser')"
    width="900px"
    @close="back"
  >
    <user-form
      v-model="value"
      :submit-label="$t('general.create')"
      :forbidden-user-list="forbiddenUserList"
      show-password
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        color="primary"
        class="ml-5"
        outlined
        @click="back"
        v-text="$t('general.cancel')"
      />
      <v-btn
        :loading="loading"
        :disabled="!isValid"
        color="accent"
        class="ml-5"
        @click="create"
        v-text="$t('general.create')"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import UserForm from '../components/UserForm'

export default {
  name: 'UserCreateContainer',
  components: {
    AgModalContainer,
    UserForm,
  },
  data: () => ({
    isValid: false,
    loading: false,
    forbiddenUserList: [],
    value: {
      userLogin: '',
      password: '',
      roles: ['COACH'],
      firstName: '',
      lastName: '',
      email: '',
      lang: '',
    },
  }),
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async create () {
      this.loading = true
      try {
        await Repositories.user.post(this.value)
        this.showSuccessNotification(this.$t('user.userCreated'))
        this.back()
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)

        // Username already exists
        if (Repositories.getErrorCode(error) === 'CreateUserLoginTakenError') {
          this.forbiddenUserList.push(this.value.userLogin)
        }
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
